const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  // {
  //   path: ["/", "/docs"],
  //   exact: true,
  //   component: "Docs",
  // },
  {
    path: ["/", "/blog"],
    exact: true,
    component: "Blog",
  },
  {
    path: ["/", "/mission"],
    exact: true,
    component: "Mission",
  },
  {
    path: ["/privacy-policy"],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/terms-and-conditions"],
    exact: true,
    component: "TermsAndConditions",
  },
  {
    path: ["/support"],
    exact: true,
    component: "Support",
  },
];

export default routes;
